import Column from '@components/column'
import Tab from '@components/tabs'
import Title from '@components/title'
import React, { Fragment } from 'react'
import PlatformSettings from './platform-settings'
import AppSettings from './app-settings'

const SystemSettings = () => {
  const items = [
    { label: 'Platform Settings', component: PlatformSettings },
    { label: 'App Settings', component: AppSettings },
  ]
  return (
    <Fragment>
      <Column>
        <Title textone="System" texttwo="Settings" />
        <Tab items={items} />
      </Column>
    </Fragment>
  )
}

export default SystemSettings
